import styled from 'styled-components';
import { StyledButton as Button } from '../../../CommonComponents/Button';
import Modal from '../../../CommonComponents/Modal';
import Dropdown from '../../../CommonComponents/Dropdown';
import FormDropdown from '../../../CommonComponents/FormDropdown/SingleOptionDropdown/SingleOptionDropdownView';

export const Wrapper = styled.div`
  padding: 0 80px 20px;
  overflow-y: auto;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
  text-align: left;
  color: #444444;
  padding: 30px 0;
`;

export const InlineDropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > * {
    flex-grow: 1;
  }

  > * + * {
    margin-left: 10px;
  }
`;

const dropDownTriggerDefaults = `
  position: relative;
  width: 100%;
  text-align: left;
`;

export const InlineDropDownTrigger = styled(Button.Secondary)`
  ${dropDownTriggerDefaults}
  display: inline-block;
  ${Button.AppendedIcon} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0.9em;
  }
`;

export const DropDownTrigger = styled(Button.Secondary)`
  ${dropDownTriggerDefaults}
  width: 100%;
  ${Button.AppendedIcon} {
    position: absolute;
    right: 0.9em;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const Optional = styled.div`
  color: #585454;
  opacity: 0.5;
  display: inline-block;
  width: auto;
`;

export const Actions = styled.div`
  position: relative;
  height: 90px;
  text-align: right;
  padding: 20px 60px;
  box-sizing: border-box;

  &:after {
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #979797;
    opacity: 0.4;
  }
`;

export const ActionButton = styled(Button)`
  display: inline-block;
  width: 160px;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`;

export const DeleteButton = styled(ActionButton)`
  color: #585454;
  font-weight: normal;
  & .fa {
    opacity: 0.6;
  }
`;

export const StyledModal = styled(Modal)`
  &__content {
    width: 550px;
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE11 style */
    &__content {
      width: 700px;
    }
  }
`;

export const StyledDropdown = styled(Dropdown)`
  width: 60%;
  button > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding-right: 5px;
    box-sizing: border-box;
  }
`;

export const SearchableDropdown = styled(FormDropdown)`
  width: 60%;
`;
